
import SearchAndSoldDataListingCards from '@/components/page-specific/search-and-sold-data/cards';
import { track } from '@/utils/analytics';
import { SoldDataEvent } from '@/constants/AnalyticEvents';
import routes from '@/constants/routes';
import Maps from '../../index';
import { MapEvents } from './enums';
import ListingsMarkerMapper from './ListingsMarkerMapper';
import InfoWindowService from '../../servises/InfoWindowService';
import MapProps from '../../mixins/MapProps';

const MODAL_LISTINGS_AMOUNT = 5;

export default {
  name: 'ListingMap',
  components: {
    Maps,
  },
  mixins: [MapProps],
  data() {
    return {
      infoWindowService: new InfoWindowService(),
    };
  },
  computed: {
    mappedMarkers() {
      return this.markersData ? ListingsMarkerMapper.createMarkerData(this.markersData) : [];
    },
    isSoldDataPage() {
      return this.$route.path === routes.soldData;
    },
  },
  mounted() {
    this.infoWindowService.init();
  },
  methods: {
    handleMapChange(value) {
      this.$emit(MapEvents.ChangePosition, value);
    },
    openInfoWindow(event) {
      if (this.isSoldDataPage) {
        track(SoldDataEvent.MapPinClick);
      }

      const { markers } = event;
      const prepareProps = () => ({
        listings: Array.isArray(markers)
          ? markers.slice(0, MODAL_LISTINGS_AMOUNT).map(({ listing }) => listing)
          : [event.marker.listing],
      });
      this.infoWindowService.openInfoWindow({
        ...event,
        component: SearchAndSoldDataListingCards,
        prepareProps,
      });
    },
  },
};
